import { useTranslation } from "@ferrivia/i18n";
import { EmptyPane } from "../../components/EmptyPane";

export function CustomersScreen() {
  const { t } = useTranslation("clinic");
  return <EmptyPane title={t("customersScreen.title", "Customers")} body={t("customersScreen.empty", "Nothing here yet.")} />;
}
